// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iDBfjGRd2OBRxkZQoG9CN","inner":"_37sP6mFCMrupKfq_tPbqC","sectionContainer":"_2wQ5oUmzP5MvEtk1QXnYYG","overflow":"_3-cf4vkH2eqBJpNYaCEyeb"};